/** Central config for OpenShell API base URL. Change this once when deploying. */
export const OPENSHELL_BASE_URL = "http://127.0.0.1:9000";
